

$(function () {

    $('.progress-pie-chart').each(function (i, obj) {
        var percent = parseInt(obj.dataset.percent);
        var deg = 360 * percent / 100;
        if (percent > 50) {
            obj.classList.add("gt-50");
        }
        $(obj).find('.ppc-progress-fill').css('transform', 'rotate(' + deg + 'deg)');
        $(obj).find('.ppc-percents span').html(percent + '%');
    });

    $(".sgkModal").sgkModal();
    $(".sgkMore").sgkMore();
});


//document.addEventListener("DOMContentLoaded", function () {
$(function () {
    try {
        if ("loading" in HTMLImageElement.prototype || !("IntersectionObserver" in window)) {
            var images = [].slice.call(document.querySelectorAll('img[loading="lazy"]'));
            var sources = [].slice.call(document.querySelectorAll("source[data-srcset]"));
            sources.forEach(function (source) {
                source.srcset = source.dataset.srcset;
            });
            images.forEach(function (img) {
                img.src = img.dataset.src;
            });
        } else {
            var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
            if ("IntersectionObserver" in window) {
                var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            var lazyImage = entry.target;
                            lazyImage.src = lazyImage.dataset.src;
                            //lazyImage.srcset = lazyImage.dataset.srcset;
                            lazyImage.classList.remove("lazy");
                            lazyImageObserver.unobserve(lazyImage);
                        }
                    });
                });

                lazyImages.forEach(function (lazyImage) {
                    lazyImageObserver.observe(lazyImage);
                });
            }
        }
    }
    catch (e) {
        alert(e);
    }

});



$(document).ready(function () {
    var hamburger = $('#hamburger-icon');
    var menu = $('#menu');
    hamburger.click(function () {
        hamburger.toggleClass('active');
        menu.toggleClass('sgkMenuClose');
        return false;
    });
});


$(function () {

    $('[data-toggle="tooltip"]').tooltip();

    $('.carousel').carousel({
        interval: 1000 * 60
    });

    $('.sgkBtnSource, .sgkPopOver').popover({ trigger: "hover", html: true });

    $('.sgkFeature, .sgkPopOver').popover({ trigger: "hover", html: true });


    $(".sgkcareerList").sortable({
        stop: function () {
            data = new Array();
            var content = $(this).closest(".divsgkEmployeeCareer");
            var employeeID = $(content.find(".divCareerHeader")).data("employeeid");
            var expertID = content.data("expertid");

            content.find(".ui-sortable-handle").each(function () {
                data.push($(this).html());
            });
            $.ajax({
                type: "POST",
                contentType: "application/json; charset=utf-8",
                url: "/Handler/Content.ashx",
                data: JSON.stringify({
                    action: "sortCareer",
                    careers: data,
                    expertID: expertID,
                    employeeID: employeeID,
                }),

            });

        }
    });





    $('.sgkInputImage').on('change', function () {
        var fileName = $(this).val().split('\\').pop();
        $(this).next('.custom-file-label').addClass("selected").html(fileName);
    });

    // Food Product Table toggle rows
    $('.sgkProductTable a').click(function () {
        $(this).closest(".row").find(".fas").toggleClass("d-none");
        $('.sgkProductTable .row-child[data-parentid=' + $(this).data("target") + "]").toggleClass("d-none");
        return false;
    });

    $('.btnCollapseSpoiler').click(function () {
        var spoiler = $(this).closest(".sgkContentSpoiler");
        spoiler.find(".colcollapseButton").collapse('hide');
        spoiler.find(".contentText2").collapse('show');


        return false;
    });


    $('.sgkAccordion .collapse').on('show.bs.collapse', function () {
        var cur = $(this).closest(".card").index();
        var active = $(this).closest(".sgkAccordion").find('.open');
        if (active.index() < cur) {
            var h = active.find(".card-body").outerHeight();
            if (typeof h !== 'undefined' && h > 100) {
                $(document).scrollTop($(document).scrollTop() - h);
            }
        }
        $(this).siblings('.card-header').addClass('active');
        $(this).closest(".sgkAccordion").find('.open').removeClass('open');
        $(this).parent().addClass('open');
    });

    $('.sgkAccordion .collapse').on('hide.bs.collapse', function () {
        $(this).siblings('.card-header').removeClass('active');
    });

    $(document).on("click", ".sgkbtnContactUs", function () {
        var data = new FormData();

        var contactForm = $(this).closest(".sgkContactForm");
        data.append("action", "contactMessage");

        var contactNameForm = contactForm.find(".sgkContactName");
        var contactEmailForm = contactForm.find(".sgkContactEmail");
        var contactMessageForm = contactForm.find(".sgkContactMessage");

        data.append("name", contactNameForm.val());
        data.append("email", contactEmailForm.val());
        data.append("message", contactMessageForm.val());

        $.ajax({
            url: "/Handler/Email.ashx",
            type: 'POST',
            data: data,
            cache: false,
            dataType: 'json',
            processData: false,
            contentType: false,
            success: function (data, textStatus, jqXHR) {

                if (data.error === false) {
                    alert("Nachricht erfolgreich verschickt.");
                }
                else {
                    alert("Fehler beim verschicken der Nachricht.");
                }

                contactNameForm.val('');
                contactEmailForm.val('');
                contactMessageForm.val('');
            },
            error: function (jqXHR, textStatus, errorThrown) {
                // Handle errors here
                // STOP LOADING SPINNER
            }
        });
    })


    $(document).on("click", ".sgkExpertCollapseTitle a", function () {
        var ref = $(this);
        ref.parents('.card').toggleClass('border-white');

        $.ajax({
            type: "POST",
            contentType: "application/json; charset=utf-8",
            url: "/Handler/TrackingHandler.ashx",
            data: JSON.stringify({
                action: "CollapseClicked",
                link: ref[0].hash
            }),
            dataType: 'json',
            success: function (data) {

            }
        });

    });

    $(document).on("click", ".sgkbtn-search", function () {

        //$(this).closest(".sgkContentCard").find(".sgkModalUnderConstruction").modal("show");
        //return false;

    });

    $(document).on("click", ".sgkbtnUnderConstructionClose", function () {

        //$(this).closest(".sgkModalUnderConstruction").modal("hide");
        //return false;

    });


    //This is bad, todo: make this better
    $(document).on("click", ".sgkbtnPrintExpert", function () {
        var printContents = $(".sgkExpertDetail")[0].innerHTML;
        var originalContents = document.body.innerHTML;

        document.body.innerHTML = printContents;

        window.print();


        document.body.innerHTML = originalContents;
    });


    $(document).on("click", ".sgkbtnPrintSurveyResult", function () {
        window.print();
    });






    //window.cookieconsent.initialise({
    //    palette: {
    //        popup: { background: "#343a40" },
    //        button: { background: "#82aa21" },
    //    },
    //    content: {
    //        message: 'Wir verwenden Cookies, um Ihnen ein optimales Nutzererlebnis zu ermöglichen',
    //        dismiss: 'OK',
    //        link: 'Mehr erfahren',
    //        href: '/Informationen/Datenschutz'
    //    },
    //    elements: {
    //        dismiss: '<a aria-label="dismiss cookie message" tabindex="0" class="btn cc-btn cc-dismiss">{{dismiss}}</a>',
    //    }
    //})


    //window.cookieconsent.initialise({
    //    "palette": {
    //        "popup": {
    //            "background": "#000"
    //        },
    //        "button": {
    //            "background": "#f1d600"
    //        }
    //    },
    //    "content": {
    //        "message": "Wir verwenden Cookies, um Ihnen ein optimales Nutzererlebnis zu ermöglichen",
    //        "dismiss": "OK",
    //        "link": "Mehr erfahren",
    //        "href": "/Informationen/Datenschutz"
    //    },

    //})

    $(document).ready(function (e) {
        $(".expert-quality-widget-container").each(function () {
            var percentage = $(this).data("percent");
            var min = 301.635;
            var max = 34.5;
            var offset = min - (min - max) * (percentage / 100);
            $(this).find(".expert-quality-widget-circle")[0].setAttribute("style", "stroke-dashoffset: " + offset + ";");
        });
    });

    $(document).ready(function (e) {
        $("input[type='radio']").each(function (idx, elm) {
            var generatedName = $(elm).attr("name");
            $(elm).attr("data-name", generatedName);
            $(elm).attr("name", $(elm).data("groupname"));
        });
    });


    $(document).on("click", ".btnSubmitSurvey", function () {
        $("input[type='radio']").each(function (idx, elm) {
            var generatedName = $(elm).data("name");
            $(elm).attr("name", generatedName);
        });
    });



    $(".form-group input[type=password]").mcPwStrength({ lang: "de" });

    window.slinky = $('#menu').slinky({
        resize: false
    });

    // prevent mobile scrolling #132
    // obsolete - #478 + #328
    /*
    var previousScrollY = 0;
    $(document).on('show.bs.modal', function () {
        previousScrollY = window.scrollY;
        $('html').addClass('modal-open').css({
            marginTop: -previousScrollY,
            overflow: 'hidden',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            position: 'fixed',
        });
        $('#sgkHeader').hide();
    }).on('hidden.bs.modal', function () {
        $('html').removeClass('modal-open').css({
            marginTop: 0,
            overflow: 'visible',
            left: 'auto',
            right: 'auto',
            top: 'auto',
            bottom: 'auto',
            position: 'static',
        });
        window.scrollTo(0, previousScrollY);
        $('#sgkHeader').show();
    });
    */

    var forms = document.getElementsByClassName('needs-validation');
    // Expert Register validation
    $('.needs-validation').submit(function (event) {
        // console.log(event);
        $(this).find("input, select").each(function () {
            if ($(this).parent().is("span")) {
                if ($(this).attr("type") == "radio") {
                    $(this).prop('required', true);
                }
                $(this).unwrap().addClass("form-check-input");
            } else {
                if ($(this).is(":visible") && $(this).data("required")) {
                    $(this).prop('required', true);
                } else {
                    $(this).prop('required', false);
                }
            }
        })

        if ($("#sgkExpertFormData").length > 0) {
            if ($(this).find("input[type=password]").length > 1) {
                if ($($(this).find("input[type=password]").get(0)).val() != $($(this).find("input[type=password]").get(1)).val()) {
                    event.preventDefault();
                    event.stopPropagation();
                    $(this).find("input[type=password]").get(1).setCustomValidity('Passwords must match');
                } else {
                    $(this).find("input[type=password]").get(1).setCustomValidity('');
                }
            }
            if ($(this)[0].checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
            }
            $(this).addClass('was-validated');
        }

        if ($("#sgkExpertFormPayment").length > 0) {
            // period
            if ($(this).find("input[value=rbPaymentMonth]").prop("checked") || $(this).find("input[value=rbPaymentYear]").prop("checked")) {
                $(".sgkExpertPaymentPeriod .card-header").removeClass("bg-danger");
                $(".sgkExpertPaymentPeriod .card-header").addClass("bg-primary text-white");
            } else {
                $(".sgkExpertPaymentPeriod .card-header").removeClass("bg-primary");
                $(".sgkExpertPaymentPeriod .card-header").addClass("bg-danger text-white");
                event.preventDefault();
                event.stopPropagation();
            }
            // method
            if ($(this).find("input[value=rbDirectDebit]").prop("checked")) {
                $(".sgkExpertPayment .card-header").removeClass("bg-danger bg-primary");
                $(this).find("input[value=rbDirectDebit]").closest(".card").find(".card-header").addClass("bg-primary text-white");
            } else if ($(this).find("input[value=rbPayPal]").prop("checked")) {
                $(".sgkExpertPayment .card-header").removeClass("bg-danger bg-primary");
                $(this).find("input[value=rbPayPal]").closest(".card").find(".card-header").addClass("bg-primary text-white");
            }
            else {
                $(".sgkExpertPayment .card-header").removeClass("bg-primary");
                $(".sgkExpertPayment .card-header").addClass("bg-danger text-white");
                event.preventDefault();
                event.stopPropagation();
            }

            if ($(this).find("input[value=rbDirectDebit]").prop("checked") && $(this)[0].checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
                $(this).addClass('was-validated');
            } else {
                $(this).removeClass('was-validated');
            }
        }

    });

    $("#sgkExpertFormPayment .sgkExpertPaymentPeriod input").change(function () {
        $("#sgkExpertFormPayment .sgkExpertPaymentPeriod .card-header").removeClass("bg-danger");
        $("#sgkExpertFormPayment .sgkExpertPaymentPeriod .card-header").addClass("bg-primary text-white");
    });

    $("#sgkExpertFormPayment .sgkExpertPayment").click(function () {
        $("#sgkExpertFormPayment .sgkExpertPayment .card-header").removeClass("bg-primary bg-danger text-white");
        $(this).find(".card-header").addClass("bg-primary text-white");
        $(this).find("input[type=radio]").prop("checked", true);
    });

    $(".sgkExpertValidationTab").click(function () {

        $(this).closest(".sgkExpertValidator").find(".collapsable").addClass("collapse");
        $(this).closest(".sgkExpertValidator").find(".page-item").removeClass("active");
        $(this).closest(".page-item").addClass("active");


        var href = $(this).attr('href');
        $(href).removeClass("collapse");
        return false;
    });


    $('.sgkTrafficLightCheckbox').click(function () {
        $(this).closest('.sgkTrafficLightContainer').find(".sgkTrafficLight").removeClass("selected");
        $(this).closest(".sgkTrafficLightContainer").find(".sgkTrafficLightCheckbox input").each(function (index, element) {
            element.value = "false";
        });

        $(this).find(".sgkTrafficLight").addClass("selected");
        $(this).find("input")[0].value = "true";
        return false;
    });



    $('.sgkSurveyQuestionCheckbox').click(function () {
        $(this).closest(".sgkSurveyQuestionContainer").find(".bg-primary").removeClass("bg-primary");
        $(this).closest(".sgkSurveyQuestionContainer").find(".sgkSurveyQuestionCheckbox input").each(function (index, element) {
            element.value = "false";
        });

        $(this).closest("div").addClass("bg-primary");
        $(this).find("input")[0].value = "true";

    });

    $('.sgkShowDetailWidget').click(function () {
        var thisSurveyID = $(this).data("surveyid");

        var textmore = "<i class=\"fas fa-plus pr-1\"></i>Mehr anzeigen";
        var textless = "<i class=\"fas fa-minus pr-1\"></i>Weniger anzeigen";

        var text = $(this).html();

        $(this).html(
            text === textmore ? textless : textmore);

        $(this).closest(".sgkSurveyResultBatch").find(".sgkShowDetailWidget").each(function (index, item) {
            if ($(item).data("surveyid") !== thisSurveyID) {

                $(item).html(textmore);
            }

        });

        $(this).closest(".sgkSurveyResultBatch").find(".collapse").each(function (index, item) {
            if ($(item).data("surveyid") === thisSurveyID && text === textmore) {

                $(item).show();
            }
            else {
                $(item).hide();
            }
        });

        return false;
    });

    $('.btnSubmitSurvey').click(function () {
        if ($(this).data("lastsubmit") === true) {

            if (!$(".sgkAcceptedSurvey").is(':checked')) {
                $(".sgkAcceptSurveyWarning").show();
                return false;
            }
        }

    });

    //Remove linkedList Background if Page is shown again (from cache)
    $(window).bind("pageshow", function (event) {
        if (event.originalEvent.persisted) {
            $(".sgklinkedlist").find(".card").removeClass("bg-primary");
        }
    });

    /*$('.sgklinkedlist').click(function () {
        var linkedListItem = $(this);
        linkedListItem.find(".card").addClass("bg-primary").addClass("text-dark");
        linkedListItem.find("div").removeAttr("style");
    });*/


    $('.sgkFixedFilterCheckbox').click(function () {

        var input = $(this).find("input")[0];
        if (input.value === "true") {
            input.value = "false";
            $(this).closest("div").removeClass("bg-primary");
        }
        else {
            input.value = "true";
            $(this).closest("div").addClass("bg-primary");
        }
        if ($(".sgkSeachPage").length > 0) {
            $(".sgkSeachPage .btnExpertSearch")[0].click();

        }
        return false;
    });

    //$('.sgkcbxFilter').on('change', function () {

    //    if ($(this).is(':checked')) {
    //        $(this)[0].value = "true";
    //    }
    //    else {
    //        $(this)[0].value = "false";
    //    }

    //});


    // Feedback
    $(document).on("click", ".sgkFeedbackYes,.sgkFeedbackNo", function () {
        var ref = $(this).parents('.sgkFeedback');
        var feedback = $(this).hasClass('sgkFeedbackYes') ? 'yes' : 'no';
        ref.find('[name="helpful"]').val(feedback);
        ref.find('.sgkFeedback0 .btn').addClass('disabled').blur();

        var data = new FormData();
        data.append("action", "feedback");
        data.append("url", document.location);
        data.append("helpful", feedback);

        //for (var pair of data.entries()) { console.log(pair[0] + ', ' + pair[1]); }
        $.ajax({
            url: "/Handler/Email.ashx",
            type: 'POST',
            data: data,
            cache: false,
            dataType: 'json',
            processData: false,
            contentType: false,
            success: function () {
                ref.find('.sgkFeedback0').addClass('d-none');
                ref.find('.sgkFeedback1').removeClass('d-none');
            },
        });

        return false;
    });
    $(document).on("click", ".skgFeedbackSubmit", function () {
        var ref = $(this).parents('.sgkFeedback');
        var message = ref.find('.sgkFeedbackMessage').val();
        var errorMessage = ref.find('.invalid-feedback');
        if (message == '') {
            errorMessage.addClass('d-block');
        } else {
            errorMessage.removeClass('d-block');

            var data = new FormData();
            data.append("action", "feedbackMsg");
            data.append("url", document.location);
            data.append("helpful", ref.find('[name="helpful"]').val());
            data.append("message", message);

            //for (var pair of data.entries()) { console.log(pair[0] + ', ' + pair[1]); }
            $.ajax({
                url: "/Handler/Email.ashx",
                type: 'POST',
                data: data,
                cache: false,
                dataType: 'json',
                processData: false,
                contentType: false
            });

            ref.find('.sgkFeedback1').addClass('d-none');
            ref.find('.sgkFeedback2').removeClass('d-none');
        }
        return false;
    });
    // /Feedback

    $(document).on("click", ".sgkToggleSegmentCollapse", function () {
        $(this).find("i").toggleClass("expanded");
        $($(this).closest(".sgkContentContent")[0].nextElementSibling).toggleClass("d-none");
        return false;
    });

});


function btnLogin_Click() {
    $('.sgkLoginButton').trigger('click');
    return false;
}